/* eslint-disable prettier/prettier */
/* eslint-disable react/button-has-type */
/* eslint-disable no-param-reassign */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable import/extensions */
import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from 'react-i18next';
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import Base64Downloader, {
  triggerBase64Download,
} from "common-base64-downloader-react";
// import { Ring } from 'react-awesome-spinners';
import ReactPlaceholder from "react-placeholder";
import {
  TextBlock,
  MediaBlock,
  TextRow,
  RectShape,
  RoundShape,
  Text,
} from "react-placeholder/lib/placeholders";
import "react-placeholder/lib/reactPlaceholder.css";

import { CommentsDisabledOutlined, TurnedIn } from "@mui/icons-material";
import {
  DownArrow,
  MailIcon,
  PrintIcon,
  Download,
  GantIcon,
  MenuIcon,
  ConstraintOuterCircle,
} from "../../Constants/assets";
import fetchConfig from "../../Constants/fetch";
import ReportsLabels from "./ReportsLabels";
import SummaryPopUp from "./SummaryPopUp";
import PlayerReport from "./PlayerReport";

const trueValue = true;

/* ToDo List

- [ ] Fix design issues and inconsistencies
- [ ] Add responsiveness to the page
- [ ] Add printing functionality
- [ ] Convert the page to pdf
- [ ] Implement the sending of the created pdf to the server
- [ ] In the server implement email sending.

////////////////////////////////// */

const Container = styled.div`
  width: 100vw;
  // margin: 0 4.2%;
  justify-content: center;
  @page {
    margin: 0cm;
  }
`;
const PageInfo = styled(Grid)`
  margin: 24px auto;
  height: 100px;
  display: flex;
  justify-content: space-between;
`;
const Column = styled.div`
  display: grid;
  align-content: space-between;
  height: 100%;
`;
const ProjectNameComponent = styled.div`
  width: 100%;
`;
const Title = styled.div`
  font-weight: bold;
  font-size: 24px;
  margin-right: 5px;
`;
const TitleComponent = styled.div`
  width: fit-content;
  display: flex;
  justify-content: space-between;
`;
const ArrowComponent = styled.div`
  width: 20px;
  display: flex;
  align-items: center;
`;
const SummaryDescriptionComponent = styled.div`
  /* width: 600px; */
`;
const PrintButton = styled.button`
  background-color: transparent;
  border: none;
`;
const SummaryDescription = styled.div`
  color: ${(props) => props.theme.colors.gray};
`;
const GameSummaryComponent = styled.div`
  text-decoration: underline;
  color: ${(props) => props.theme.colors.darkGreen};
  cursor: pointer;
  width: fit-content;
`;
const FieldComponent = styled.div`
  display: grid;
  // max-width: fit-content;
`;
const Label = styled.div`
  color: ${(props) => props.theme.colors.gray};
  text-align: left;
  width: 235px;
`;
const LabelLine = styled.div`
  display: flex;
  justify-content: space-between;
  direction: ltr;
`;
const TopIcons = styled.div`
  display: flex;
  justify-content: space-between;
`;
const MenusSwitchContainer = styled.div`
  display: flex;
  border: 1px solid ${(props) => props.theme.colors.gray};
  box-sizing: border-box;
  border-radius: 5px;
  justify-content: space-around;
`;
// Switch Logic CSS
const SwitchRightSide = styled.div`
    width: 100 %;
    text - align - last: center;
    ${(props) =>
    props.stage == 1
      ? css`
            background: ${(componentProps) =>
          componentProps.theme.colors.lightGreen};
          `
      : css`
            background: white;
            cursor: pointer;
          `};
`;
const SwitchLeftSide = styled.div`
    width: 100 %;
    text - align - last: center;
    ${(props) =>
    props.stage == 0
      ? css`
            background: ${(componentProps) =>
          componentProps.theme.colors.lightGreen};
          `
      : css`
            background: white;
            cursor: pointer;
          `};
`;
const TableInfoContainer = styled.tr`
  height: 25px;
  margin-bottom: 10px;
  margin: 0px 15px 0px 10px;
  justify-content: space-between;
  display: flex;
  width: 98%;
`;
const SectionContainer = styled.th`
  width: ${(props) => props.width}%;
  text-align: ${(props) => props.align};
  margin-right: ${(props) => props.marginR}%;
`;
const Table = styled.table`
  width: 100%
`;
const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 400 !important;
  color: ${(props) => props.theme.colors.gray};
`;
let condition = false;
// eslint-disable-next-line prefer-const
let pdfHasSent = false;
export default function Report({
  socketIO,
  gameLogData,
  projectId,
  projectName,
  projectObjective,
  shortReport,
  playersFullName,
  turnNumber,
  logSideBar,
  totalValue,
  totalBudget,
  regularResources,
  seniorResources,
  expensiveResources,
  turn,
  playerEmail,
  amountResourcesExpensive,
  userId,
  isPaused,
  sendUserPreviousGames,
  tasksArray,
  isItAPreviousReport,
  toggleReport,
  sideLogUpdateToCurrentOne,
  downloadReport,
  toggleDownloadReport,
  gameStartTime,
  gameStartDate,
  restartGameFunction,
  playerName,
  email,
  logout,
  gameGoals,
  tasks,
  finalGrade,
  getReportTest,
  previousReportsGameLogData,
  gameUIdOfPrevGame,
  downloadReportFunc,
  getCommentsTable,
}) {
  const [pdfFile, setPdf] = useState("");
  const [stage, setStage] = useState(0);
  const [popUp, setPopUp] = useState(!isItAPreviousReport);
  const [expand, setExpand] = useState(false);
  const [expandedState, setExpandedState] = useState(false);
  const [mailed, setMailed] = useState(false);
  const [cursorType, setCursorType] = useState("pointer");
  const [isLoading, setIsLoading] = useState(true);
  const [showLabels, setshowLabels] = useState(false);
  const [Labels, setLabels] = useState([]);
  const [gameStartTimeDate, setGameStartTimeDate] = useState('')
  const [commentsList, setCommentsList] = useState([]);
  const [renderEmbed, setRenderEmbed] = useState(true);
  // const [reportLabels, setreportLabels] = useState([]);
  const itemRef = [];
  const arrOfComents = [];
  const indexOfComments = [];
  const data = useRef();
  const summaryReportData = useRef();
  const { t } = useTranslation();
  socketIO.emit("game-completed");  // - do not remove
  useEffect(() => {
    let isSubscribed = true;
    let dataNew;
    const getData = async () => {
      setCommentsList(await getCommentsTable());
      if (isLoading) {
        if (isItAPreviousReport) {
          const obj = {
            prevGameId: gameUIdOfPrevGame,
            userId,
          };
          data.current = await getReportTest({
            gameAndUserIdObj: obj,
            needssummaryReport: true,
            sendByMail: true,
            previousReport: "download",
          });
        } else {
          data.current = await getReportTest({
            lastPlayData: false,
            needssummaryReport: true,
            sendByMail: true,
            // previousReport: 'download'
            // when set do download we just get the report
            // when set to undefined we get the file AND send email
            reportPageDownLoad: true,
          });
        }
        if (typeof data.current.data != "string") setIsLoading(false);
      }
    };
    async function parseDataToComponent() {
      if (isLoading) await getData();
      const temporaryLabels = [];
      if (!isLoading && !showLabels) {
        console.log("Start parsing data...", data);
        Object.keys(data.current.data).map((current, index) => {
          if (data.current.data[current].cardData !== null || data.current.data[current]?.turnData?.code == 10) { // additional resources doesnt necessarily have card data
            temporaryLabels.push(data.current.data[current]);
          }
        });
        console.log(
          "Done parsing data. ShowLabels: ",
          showLabels,
          temporaryLabels
        );
        return temporaryLabels;
      }
    }

    if (!showLabels) {
      console.log("Fetching data..");
      dataNew = parseDataToComponent()
        .then((data1) => {
          console.log("raw data1", data1)
          summaryReportData.current = data1.pop();
          setLabels(data1);
          setshowLabels(true);
          console.log("summaryReportData ", summaryReportData);
          const currentDate = new Date(summaryReportData.current.startGameTime);
          const actionTime = currentDate.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
          const year = currentDate.getFullYear();
          const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
          const day = currentDate.getDate().toString().padStart(2, '0');
          setGameStartTimeDate(`${year}/${month}/${day}; ${actionTime}`)
        })
        .catch((err) => console.log(err));
    } else if (showLabels) {
      return () => {
        console.log("Done fetching. showLabels: ", Labels);
      };
    }
    return () => {
      isSubscribed = false;
    };
  }, [
    isLoading,
    data,
    showLabels,
    getReportTest,
    Labels,
    isItAPreviousReport,
    gameUIdOfPrevGame,
    userId,
    getCommentsTable
  ]);
  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  const printFormat = (isEmail = false) => {
    if (isEmail) {
      return;
    }
    const blob = b64toBlob(summaryReportData.current.pdf, "application/pdf");
    const blobUrl = URL.createObjectURL(blob);


    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = blobUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };
  };

  const generatePDF = () => {
    printFormat(true);
    if (!condition) {
      condition = true;
      setTimeout(() => {
        const element = document.body;
        drawDOM(element, {
          // paperSize: 'A4',
          multiPage: true,
          scale: 0,
        })
          .then((group) => {
            return exportPDF(group);
          })
          .then((dataUri) => {
            // sendUserPreviousGames([dataUri, pdfFile]);
            if (downloadReport) {
              // triggerBase64Download(dataUri, "PM_Zone Game Report"); // download the pdf;
              const currentDate = new Date();
              currentDate.setHours(currentDate.getHours() + 3);
              const formattedDate = currentDate.toISOString().split('T')[0];
              const formattedTime = currentDate.toISOString().split('T')[1].split('.')[0];
              const reportName = `PMzone-Simulation-Board-Game-Player-Summary-Report-${formattedDate}-${formattedTime}`;
              triggerBase64Download(dataUri, reportName); // download the pdf with the updated name

            } else {
              // window.open(dataUri); // just open pdf
              const win = window.open();
              win.document.write(
                `<iframe src="${dataUri}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
              );
            }
            toggleDownloadReport(false);
            sideLogUpdateToCurrentOne(false);
            toggleReport(false); // now close report.
            condition = false;
          });
      }, 2500);
    }
  };
  const exportPDFToEmail = () => {
    printFormat(true);

    setTimeout(() => {
      const element = document.body;
      drawDOM(element, {
        // paperSize: 'A4',
        multiPage: true,
        scale: 0,
      })
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataUri) => {
          axios.post(`${fetchConfig.prefix}/project/sendPDF`, {
            data: [dataUri, pdfFile],
            userId,
            playerEmail,
            startGameTimeAsFullUtcString: summaryReportData.current?.startGameTimeAsFullUtcString
          });
        });
    }, 500);
  };
  const exportPDFAndSave = () => {
    printFormat(true);

    setTimeout(() => {
      const element = document.body;
      drawDOM(element, {
        // paperSize: 'A4',
        multiPage: true,
        scale: 0,
      })
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataUri) => {
          // saveAs([dataUri, pdfFile], 'PM_Zone Game Report');
          // triggerBase64Download(dataUri, "PM_Zone Game Report");
          const currentDate = new Date();
          currentDate.setHours(currentDate.getHours() + 3);
          const formattedDate = currentDate.toISOString().split('T')[0];
          const formattedTime = currentDate.toISOString().split('T')[1].split('.')[0];
          const reportName = `PMzone-Simulation-Board-Game-Player-Summary-Report-${gameStartTime}-${gameStartDate}`;
          triggerBase64Download(dataUri, reportName); // download the pdf with the updated name
        });
    }, 500);
  };

  const setRef = (el) => {
    if (el !== null) {
      itemRef.push(el);
    }
  };

  const shortSummaryPdf = (dataUri) => {
    setPdf(dataUri);
  };
  return (
    <>
      {isItAPreviousReport &&
        showLabels &&
        Labels !== undefined &&
        previousReportsGameLogData[previousReportsGameLogData.length - 1] !==
        undefined &&
        previousReportsGameLogData[0] != "E" && ( // 'E' - means error
          <SummaryPopUp
            projectId={projectId}
            tasks={tasks}
            gameStartTime={gameStartTimeDate}
            playersFullName={playersFullName}
            playerEmail={playerEmail}
            setPopUp={setPopUp}
            shortReport={shortReport}
            logSideBar={logSideBar}
            amountResourcesExpensive={amountResourcesExpensive}
            shortSummaryPdf={shortSummaryPdf}
            sendUserPreviousGames={sendUserPreviousGames}
            tasksArray={tasksArray}
            isItAPreviousReport={isItAPreviousReport}
            data={data}
            newData={
              previousReportsGameLogData[previousReportsGameLogData.length - 1]
            }
            restartGameFunction={restartGameFunction}
            playerName={playerName}
            email={email}
            logout={logout}
            showLabels={showLabels}
            gameGoals={gameGoals}
            finalGrade={finalGrade}
            gameStartDateTimeString={summaryReportData.current?.startGameTimeAsFullUtcString ?? ""}
            userId={userId}
          />
        )}
      <Container id="list">
        {popUp && (
          <SummaryPopUp
            projectId={projectId}
            tasks={tasks}
            gameStartTime={gameStartTimeDate}
            playersFullName={playersFullName}
            playerEmail={playerEmail}
            setPopUp={setPopUp}
            shortReport={shortReport}
            logSideBar={logSideBar}
            amountResourcesExpensive={amountResourcesExpensive}
            shortSummaryPdf={shortSummaryPdf}
            sendUserPreviousGames={sendUserPreviousGames}
            tasksArray={tasksArray}
            isItAPreviousReport={isItAPreviousReport}
            // data={summaryReportData.current}
            newData={summaryReportData.current}
            restartGameFunction={restartGameFunction}
            playerName={playerName}
            email={email}
            logout={logout}
            showLabels={showLabels}
            exportPDFToEmail={exportPDFToEmail}
            gameGoals={gameGoals}
            finalGrade={finalGrade}
            gameStartDateTime={gameStartTimeDate}
            gameStartDateTimeString={summaryReportData.current?.startGameTimeAsFullUtcString ?? ""}
            userId={userId}
          />
        )}
        <>
          {!condition &&
            isItAPreviousReport &&
            setTimeout(() => generatePDF(), 4500)}

          <Table>
            {stage == 0 && !isItAPreviousReport && Labels && (
              <ReactPlaceholder
                showLoadingAnimation={trueValue}
                type="media"
                ready={showLabels}
                rows={2}
              >
                {summaryReportData.current && (() => {
                  let gameStatus;

                  if (summaryReportData.current?.playerQuit) {
                    gameStatus = "abandoned";
                  } else if (summaryReportData.current?.projectCanceled) {
                    gameStatus = "canceled";
                  } else {
                    gameStatus = "completed";
                  }

                  return (
                    <PlayerReport
                      printFormat={printFormat}
                      exportPDFToEmail={exportPDFToEmail}
                      setMailed={setMailed}
                      setCursorType={setCursorType}
                      downloadReportFunc={downloadReportFunc}
                      mailed={mailed}
                      cursorType={cursorType}
                      reportJSON={summaryReportData.current}
                      commentsList={commentsList}
                      setRef={setRef}
                      playerName={playersFullName?.length ? playersFullName : playerName}
                      projectName={t(`global_variables.projects.${projectId}.project_name`, { projectId })}
                      initialBudget={summaryReportData.current.projectData[0].budget}
                      gameDate={new Date(summaryReportData.current.startGameTime).toISOString(undefined, { hour12: false })}
                      gameID={summaryReportData.current.gameId}
                      gameScore={summaryReportData.current.newPlayerGrade?.total_score || 0}
                      initialResources={{
                        Standard: summaryReportData.current.projectData[0].standard,
                        Senior: summaryReportData.current.projectData[0].senior,
                        Executive: summaryReportData.current.projectData[0].executive
                      }}
                      email={summaryReportData.current.playersEmail}
                      projectGoal={t(`global_variables.projects.${projectId}.project_objective`, { projectId })}
                      gameDuration={summaryReportData.current.gameTimerDB}
                      gameStatus={gameStatus}  // Now using the pre-defined variable
                      assistanceMode={summaryReportData.current.isAssistantEnabled ? "On" : "Off"}
                      actions={Labels}
                      setPopUp={setPopUp}
                    />
                  );
                })()}



                { /* {Labels.map((element, index) => {
                  return (
                    <ReportsLabels
                      commentsList={commentsList}
                      data={element}
                      key={element.turnData.id}
                      setRef={setRef}
                      // {...current}
                      expand={expand}
                    />
                  );
                })} 
                  
                bakbak  */}
              </ReactPlaceholder>
            )}
            {stage == 0 &&
              isItAPreviousReport &&
              previousReportsGameLogData[0] != "E" &&
              previousReportsGameLogData.map((element, index) => {
                if (index < previousReportsGameLogData.length - 1) {
                  return (
                    <ReportsLabels
                      commentsList={commentsList}
                      data={element}
                      key={element.turnData.id}
                      setRef={setRef}
                      // {...current}
                      expand={expand}
                    />
                  );
                }
              })}
          </Table>
        </>
      </Container>
    </>
  );
}
